"use strict";

var React = require('react');
var ReactForms = require('react-forms');
var ScalarNode = ReactForms.schema.ScalarNode;
var createNode = ReactForms.schema.createNode;

var Field = require('ofs/forms/components/better-field');

function TextScalar(props) {
  props.input = props.input || <textarea className="ofs-Input ofs-Input--textarea" />;
  props.type = 'string';
  props.component = Field;
  return createNode(ScalarNode, props);
}

module.exports = TextScalar;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/scalars/TextScalar.jsx
 **/